module.exports = {};


// WEBPACK FOOTER //
// ../src4js/pc4mobx/edc/single4com.js